var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"placeholder":"请选择","allowClear":""},on:{"change":_vm.onValueChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.options),function(item){return _c('a-select-option',{key:item.code,attrs:{"value":item.code}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }